import type { Partner_Partner as Partner } from '__generated__/graphql-types-do-not-use';

import path from 'js/lib/path';

export function getPartnerPageUrl(partner: Pick<Partner, 'homePageOverride' | 'slug'>) {
  if (partner.homePageOverride) {
    return partner.homePageOverride;
  } else {
    return path.join('/partners', partner.slug);
  }
}
